import { __rest } from '../../_virtual/_tslib.js';
import React__default, { useEffect } from 'react';
import Styles from './QuickFilterPillGroup.module.scss.js';
import NewQuickFilterPill from '../new-quick-filter-pill/NewQuickFilterPill.js';

const QuickFilterPillGroup = (_a) => {
    var { options, isMultiSelect = false, id } = _a, props = __rest(_a, ["options", "isMultiSelect", "id"]);
    const { selected: multiSelected, onFilterChange: multiSelectFilterChange } = props;
    const { selected: singleSelected, onFilterChange: singleSelectFilterChange } = props;
    const handleClick = (id) => {
        if (isMultiSelect && multiSelected) {
            const arr = [...multiSelected];
            const index = arr.indexOf(id);
            if (index > -1) {
                arr.splice(index, 1);
            }
            else {
                arr.push(id);
            }
            multiSelectFilterChange(arr);
        }
        else {
            singleSelectFilterChange(id);
        }
    };
    const isOptionSelected = (id) => {
        if (isMultiSelect && multiSelected) {
            return multiSelected.includes(id);
        }
        else
            return singleSelected === id;
    };
    useEffect(() => {
        const obj = {};
        for (const option of options) {
            if (obj[option.id]) {
                obj[option.id] += 1;
            }
            else {
                obj[option.id] = 1;
            }
        }
        for (const [key, value] of Object.entries(obj)) {
            if (value !== 1)
                throw new Error(`Found ${value} options with same id "${key}", options are passed to the QuickFilterPillGroup`);
        }
    }, [options]);
    return (React__default.createElement("div", { className: Styles.quickFilterPillContainer, id: id }, options.map((option) => (React__default.createElement("div", { className: Styles.quickFilterPillWrapper, key: option.id },
        React__default.createElement(NewQuickFilterPill, { key: option.id, content: option.value, id: option.id, handleClick: handleClick, isSelected: isOptionSelected(option.id), disabled: option.disabled }))))));
};

export { QuickFilterPillGroup as default };
//# sourceMappingURL=QuickFilterPillGroup.js.map
